document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("globoFilterRenderCompleted", function (e) {
    //select the prices
    const priceElements = document.querySelectorAll(".money");

    priceElements.forEach((priceElement) => {
      const priceText = priceElement.textContent.trim();

      //Check if the price ends in ".00" then remove it
      if (priceText.endsWith(".00")) {
        priceElement.textContent = priceText.slice(0, -3);
      }
    });
  });
});
